import { useSelector } from 'react-redux';
import useWatchTime from 'src/hooks/useWatchTime';
import useInterval from 'src/hooks/useInterval';
import useTracking from 'src/hooks/useTracking';
import { SELECTOR_PLAYBACK_READY } from 'src/store/reducers/playback';
import { BUFFER_UPDATE_INTERVAL, TRACK_PROGRESS_INTERVAL } from './constants';

function usePlayerIntervals() {
  const playerReady = useSelector(SELECTOR_PLAYBACK_READY);

  const { updateBufferIndicator } = useWatchTime();
  const { trackProgress } = useTracking();

  useInterval(updateBufferIndicator, BUFFER_UPDATE_INTERVAL, playerReady);
  useInterval(trackProgress, TRACK_PROGRESS_INTERVAL, playerReady);
}

export default usePlayerIntervals;
